import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreAgentConversationChunksSlice } from './get';

export const coreAgentConversationChunksReducers = combineReducers({
	get: getCoreAgentConversationChunksSlice.asyncReducers
});

export const coreAgentConversationChunksWatchers = combineAllWatchers([
	getCoreAgentConversationChunksSlice.asyncWatchers
]);
